import {ADD_SITE, TOGGLE_SEARCH, TOGGLE_MENU, TOGGLE_LANG, CLOSE_LANG, TOGGLE_NAV} from "./types"

const addSite = (site, state) => {
  return{
    ...state,
    site: site
  }
}

const toggleSearch = (payload, state) => {

  return {
    ...state,
    site: {
      ...state.site,
      search: payload
    }
  }
}

const toggleMenu = (payload, state) => {
  return{
    ...state,
    menuState: payload
  }
}

const toggleLang = (payload, state) => {
  return{
    ...state,
    langState: payload
  }
}

const closeLang = (payload, state) => {
  return{
    ...state,
    langState: payload
  }
}

const toggleNav = (payload, state) => {
  const newNavBar = state.site.navBar.map(item => {
    if(payload === item.key) {
      item.isOpen = !item.isOpen
    } else {
      item.isOpen = false
    }
    return item
  })

  return {
    ...state,
    site: {
      ...state.site,
      navBar: newNavBar
    }
  }
}

export default (state, action) => {
  switch(action.type) {
    case ADD_SITE:
      return addSite(action.payload, state)
    case TOGGLE_SEARCH:
      return toggleSearch(action.payload, state)
    case TOGGLE_MENU:
      return toggleMenu(action.payload, state)
    case TOGGLE_LANG:
      return toggleLang(action.payload, state)
    case CLOSE_LANG:
      return closeLang(action.payload, state)
    case TOGGLE_NAV:
      return toggleNav(action.payload, state)
    default: 
      return state
  }
}